const CLIENT_ID = "a693eeb8-335a-412c-bbc5-8c4c01e3e5f2";

const PROJECT_ID = "9ca1cf87-456d-4bba-8cd8-2fba5d9be15a";

const PROJECT_NAME = "client-project";

export { CLIENT_ID, PROJECT_ID, PROJECT_NAME };
